import React from 'react';
import ExamsWithoutResultsWidget from './Widgets/ExamsWithoutResultsWidget';
import ExamsWithoutResultsFilteredWidget from './Widgets/User/ExamsWithoutResultsFilteredWidget';
import FollowUpTrackingFilteredWidget from './Widgets/User/FollowUpTrackingFilteredWidget';
import UnperformedExamsWidget from './Widgets/UnperformedExamsWidget';
import FollowUpTrackingWidget from './Widgets/FollowUpTrackingWidget';
import IncompleteExamsWidget from './Widgets/IncompleteExamsWidget';
import ResultLettersNotPrintedWidget from './Widgets/ResultLettersNotPrintedWidget';
import TechSummaryWidget from './Widgets/TechSummaryWidget';
import MissingSameDayProviderVisitsWidget from './Widgets/MissingSameDayProviderVisitsWidget';

/**
 * WidgetContent component
 * Renders the actual content for each widget type
 * @param {Object} widget - The widget object
 * @param {Object} sharedState - Shared state for filters between views
 */
export default function WidgetContent({ widget, sharedState, setSharedState }) {
const widgetKey = widget?.widgetDefinition?.widgetKey;
const isCollapsed = sharedState?.isCollapsed || false;
const isExpanded = sharedState?.isExpanded || false;
const setIsLoading = sharedState?.setIsLoading;
const queryEnabled = sharedState?.queryEnabled ?? true;

// Render different content based on widget type
switch (widgetKey) {
    case 'exams-without-results':
        return <ExamsWithoutResultsWidget isCollapsed={isCollapsed} isExpanded={isExpanded} setIsLoading={setIsLoading} setSharedState={setSharedState} queryEnabled={queryEnabled} />;

    case 'no-results-entered':
        return <ExamsWithoutResultsFilteredWidget widget={widget} isCollapsed={isCollapsed} isExpanded={isExpanded} setIsLoading={setIsLoading} setSharedState={setSharedState} />;

    case 'unperformed-exams':
        return <UnperformedExamsWidget isCollapsed={isCollapsed} isExpanded={isExpanded} setIsLoading={setIsLoading} setSharedState={setSharedState} queryEnabled={queryEnabled} />;

    case 'follow-up-tracking':
        return <FollowUpTrackingWidget isCollapsed={isCollapsed} isExpanded={isExpanded} setIsLoading={setIsLoading} setSharedState={setSharedState} queryEnabled={queryEnabled} />;

    case 'follow-up-tracking-user':
        return <FollowUpTrackingFilteredWidget widget={widget} isCollapsed={isCollapsed} isExpanded={isExpanded} setIsLoading={setIsLoading} setSharedState={setSharedState} />;

    case 'incomplete-exams':
        return <IncompleteExamsWidget isCollapsed={isCollapsed} isExpanded={isExpanded} setIsLoading={setIsLoading} setSharedState={setSharedState} queryEnabled={queryEnabled} />;

    case 'result-letters-not-printed':
        return <ResultLettersNotPrintedWidget isCollapsed={isCollapsed} isExpanded={isExpanded} setIsLoading={setIsLoading} setSharedState={setSharedState} queryEnabled={queryEnabled} />;

    case 'missing-same-day-provider-visits':
        return <MissingSameDayProviderVisitsWidget isCollapsed={isCollapsed} isExpanded={isExpanded} setIsLoading={setIsLoading} setSharedState={setSharedState} queryEnabled={queryEnabled} />;

    case 'tech-summary-and-detail':
        return <TechSummaryWidget widget={widget} isCollapsed={isCollapsed} isExpanded={isExpanded} setIsLoading={setIsLoading} setSharedState={setSharedState} />;

        case 'open-exams':
            return <FacilityStatsWidget widget={widget} />;

        case 'bi-rads-distribution':
            return <BiRadsDistributionWidget widget={widget} />;

        case 'quick-actions':
            return <QuickActionsWidget widget={widget} />;

        case 'recent-patients':
            return <RecentPatientsWidget widget={widget} />;

        default:
            return <DefaultWidget widget={widget} />;
    }
}

// Sample widget implementations
// Replace these with your actual widget components

function OpenExamsWidget({ widget, sharedState }) {
    const widgetKey = widget?.widgetDefinition?.widgetKey || '';
    return (
        <div className="text-center py-12 text-zinc-500 dark:text-zinc-400">
            <p className="text-sm">Widget type not implemented: {widgetKey}</p>
        </div>
    );
}

function PendingResultsWidget({ widget }) {
    return (
        <div className="text-center py-12 text-zinc-500 dark:text-zinc-400">
            <p className="text-sm">Widget type not implemented: pending-results</p>
        </div>
    );
}

function RecentRecallsWidget({ widget }) {
    return (
        <div className="text-center py-12 text-zinc-500 dark:text-zinc-400">
            <p className="text-sm">Widget type not implemented: recent-recalls</p>
        </div>
    );
}

function UnsignedReportsWidget({ widget }) {
    return (
        <div className="text-center py-12 text-zinc-500 dark:text-zinc-400">
            <p className="text-sm">Widget type not implemented: unsigned-reports</p>
        </div>
    );
}

function FacilityStatsWidget({ widget }) {
    return (
        <div className="text-center py-12 text-zinc-500 dark:text-zinc-400">
            <p className="text-sm">Widget type not implemented: facility-stats</p>
        </div>
    );
}

function BiRadsDistributionWidget({ widget }) {
    return (
        <div className="text-center py-12 text-zinc-500 dark:text-zinc-400">
            <p className="text-sm">Widget type not implemented: bi-rads-distribution</p>
        </div>
    );
}

function QuickActionsWidget({ widget }) {
    return (
        <div className="text-center py-12 text-zinc-500 dark:text-zinc-400">
            <p className="text-sm">Widget type not implemented: quick-actions</p>
        </div>
    );
}

function RecentPatientsWidget({ widget }) {
    return (
        <div className="text-center py-12 text-zinc-500 dark:text-zinc-400">
            <p className="text-sm">Widget type not implemented: recent-patients</p>
        </div>
    );
}

function DefaultWidget({ widget }) {
    return (
        <div className="p-4 text-center text-gray-500">
            <div className="text-sm">
                Widget: {widget?.widgetDefinition?.widgetName || 'Unknown'}
            </div>
            <div className="text-xs mt-2">
                Content coming soon...
            </div>
        </div>
    );
}
